import React from "react";
import Col from "react-bootstrap/Col";
import Nav from "react-bootstrap/Nav";
import Row from "react-bootstrap/Row";
import Tab from "react-bootstrap/Tab";
import Loading from "../../Components/Loading";
import Accreditation from "./Components/Accreditation";
import Edit from "./Components/Edit";
import Preview from "./Components/Preview";
import { useSingle } from "./Hooks";
const SingleAds = () => {
  const {
    form,
    setForm,
    loading,
    renderStatus,
    value,
    handler,
    user,
    saveChange,
    publishHandler,
    error,
    validate,
  } = useSingle();
  if (loading.show) {
    return <Loading />;
  }
  return (
    <>
      <div className="card mb-3 profile">
        <div className="card-body bg-light">
          <div className="row">
            <div className="col mb-2 d-flex justify-content-between">
              <div>
                <h5 className="fs-16 mb-2">
                  وضعیت آگهی : {renderStatus(form.status)["title"]}
                </h5>
                {renderStatus(form.status)["edit"] ? (
                  <></>
                ) : (
                  <>
                    <p className="mt-2 mb-4" style={{ fontSize: "12px" }}>
                      آگهی مورد نظر قابل ویرایش نیست
                    </p>
                  </>
                )}
              </div>

              <div>
                <span> شناسه اگهی : </span>
                <span className="mb-4"> {form.code}</span>
              </div>
            </div>
          </div>
          <Tab.Container id="left-tabs-example" defaultActiveKey="first">
            <Row>
              <Col sm={2}>
                <Nav variant="pills" className="flex-column">
                  <Nav.Item>
                    <Nav.Link eventKey="first">پیش نمایش</Nav.Link>
                  </Nav.Item>
                  {renderStatus(form.status)["edit"] && (
                    <Nav.Item>
                      <Nav.Link eventKey="second">ویرایش</Nav.Link>
                    </Nav.Item>
                  )}
                  {renderStatus(form.status).buyPlan &&
                    <Nav.Item>
                      <Nav.Link eventKey="third"> ارتقاء آگهی </Nav.Link>
                    </Nav.Item>
                  }
                </Nav>
              </Col>
              <Col sm={10}>
                <Tab.Content>
                  <Tab.Pane eventKey="first">
                    <Preview form={form} />
                  </Tab.Pane>
                  {renderStatus(form.status) && (
                    <Tab.Pane eventKey="second">
                      <Edit
                        user={user}
                        form={form}
                        setForm={setForm}
                        handler={handler}
                        value={value}
                        loading={loading}
                        saveChange={saveChange}
                        publishHandler={publishHandler}
                        error={error}
                        validate={validate}
                      />
                    </Tab.Pane>
                  )}

                  {renderStatus(form.status).buyPlan &&
                    <Tab.Pane eventKey="third">
                      <Accreditation form={form} />
                    </Tab.Pane>
                  }

                </Tab.Content>
              </Col>
            </Row>
          </Tab.Container>
        </div>
      </div>
    </>
  );
};
export default SingleAds;
